// extracted by mini-css-extract-plugin
export default {"host":"Asset_host__p8lMC","name":"Asset_name__gxXNv","image":"Asset_image__8kLTs"};